import React from 'react'
import { Link } from 'react-router-dom'

const TABS = [
    { key: "all", label: "All Modules", to: "/demo/mdm" },
    { key: "android", label: "Android", to: "/demo/mdm/android" },
    { key: "ios", label: "iOS", to: "/demo/mdm/ios" },
    { key: "windows", label: "Windows", to: "/demo/mdm/windows" },
]

const MdmTabs = ({ active }) => (
    <div className="mdm-tabs" role="tablist" aria-label="Filter by platform">
        {TABS.map((tab) => (
            tab.key === active
                ? <span key={tab.key} className="mdm-tab mdm-tab-active" role="tab" aria-selected="true">{tab.label}</span>
                : <Link key={tab.key} className="mdm-tab" to={tab.to} role="tab" aria-selected="false">{tab.label}</Link>
        ))}
    </div>
)

export default MdmTabs
